import React, { Component } from "react";
import LearningContent from "../function-components/Learning/LearningContent";

function Learning({languageValue, setLanguageValue}) {
    return (
      <>
        <LearningContent languageValue={languageValue} setLanguageValue={setLanguageValue}/>
      </>
    );
  }

export default Learning;
